/* eslint-disable react/jsx-no-constructed-context-values */
import React, { useContext, createContext, useCallback } from 'react';
import api from '../services/api';
import { IPaymentIntent } from '../models/IPaymentIntent';

interface StripeData {
  createIntent: (amount: number) => Promise<IPaymentIntent>;
}

const Stripe = createContext<StripeData>({} as StripeData);

interface IStripeProvider {
  children: React.ReactNode;
}

export const StripeProvider: React.FC<IStripeProvider> = ({ children }) => {
  const createIntent = useCallback(async (amount: number) => {
    const response = await api.post<IPaymentIntent>('/restricted/payment-transactions/intents', {
      amount,
    });
    return response.data;
  }, []);

  return <Stripe.Provider value={{ createIntent }}>{children}</Stripe.Provider>;
};

export function usePaymentStripe(): StripeData {
  const context = useContext(Stripe);

  if (!context) {
    throw new Error('usePaymentStripe must be used within StripeProvider');
  }

  return context;
}
